<template>
    <div class="w-full lg:w-[55%] ml-0 lg:ml-10 p-4 lg:px-10 lg:py-5">
        <div>
            <div class="flex items-center w-full gap-2">
                <button @click="handlegoback"
                    class="px-2 py-1 hover:border hover:border-gray-300 bg-transparent rounded-md transition">
                    <img src="@/assets/images/icons/arrows/left-angle.svg" alt="">
                </button>
                <h2 class="font-mulish text-2xl text-[#053A51] text-left font-bold">
                    Upload Bulk Staff Promotion
                </h2>
            </div>
            <p class="font-mulish text-sm font-semibold text-left text-[#053A51]">
                Use this tool to initiate bulk service promotion for existing staff members
            </p>
        </div>

        <!-- Loading placeholder -->
        <div v-if="loading" class="flex justify-center items-center h-[200px]">
            <div class="loader border-4 border-t-4 border-gray-200 rounded-full w-12 h-12 animate-spin"></div>
        </div>

        <!-- Content after data is loaded -->
        <div v-else>
            <div v-for="(item, index) in items" :key="index"
                class="flex items-center my-4 justify-between py-[12px] px-[16px] w-full bg-white shadow-md border border-[#C7C7C7] rounded-[5px]">
                <div class="text-gray-800 font-medium">
                    {{ item.name }}
                </div>
                <div v-if="item.name === 'Verification Status'" class="flex flex-col justify-end items-end gap-1">
                    <p class="font-mulish text-sm text-[#484848] font-semibold">
                        Validation
                        <span :class="{
                            'text-green-600 y-1 px-2 rounded-full bg-[#187A331A] font-semibold': item.value === 'Successful',
                            'text-red-600 py-1 px-2 rounded-full bg-[#FF00001A] font-semibold': item.value === 'Failed'
                        }">
                            {{ item.value }}
                        </span>
                    </p>
                    <p class="font-mulish text-sm text-[#484848] font-semibold">
                        Click to
                        <a :href="approvedTemplateUrl" download
                            class="text-[#0090FF] underline text-sm hover:text-[#0090FF]">
                            Download Report
                        </a>
                    </p>
                </div>
                <div v-else class="flex flex-col justify-end items-end gap-2">
                    <p class="font-mulish text-sm text-[#484848] font-semibold">
                        {{ item.value }}
                    </p>
                </div>
            </div>

            <div class="flex gap-2 justify-end items-end w-full mt-4">
                <button v-if="getStatus() === 'Successful'" @click="submitItem"
                    class="px-4 w-[143px] h-[56px] bg-[#1A8103] text-[#fff] rounded-lg transition">
                    Submit
                </button>
                <button @click="downloadItem"
                    class="px-4 w-[143px] h-[56px] bg-[#F2F9FF] text-[#0090FF] border border-[#0090FF] rounded-lg transition">
                    Download
                </button>
                <button @click="deleteItem"
                    class="px-4 w-[143px] h-[56px] bg-[#FFECEC] text-[#FF0000] rounded-lg  transition">
                    Delete
                </button>
            </div>
        </div>
    </div>
</template>


<script>
import router from "@/router";
import { fetchPromotion } from "@/services/sourceData";
import Swal from "sweetalert2";

export default {
    name: "BulkPromotionUploadStatus",
    data() {
        return {
            loading: true,
            approvedTemplateUrl: "",
            items: [
                { name: "Verification Status", value: "" },
                { name: "Verification Duration", value: "" },
                { name: "Verification Start Time", value: "" },
                { name: "Verification End Time", value: "" },
                { name: "Number of Records", value: "" },
                { name: "Uploaded On", value: "" },
                { name: "Uploaded By", value: "" },
            ],
        };
    },
    async beforeMount() {
        try {
            const batchId = this.$route.params.id;
            const res = await fetchPromotion(batchId);


            const data = res;
            this.items = [
                { name: "Verification Status", value: data.validationStatus === "successful" ? "Successful" : "Failed" },
                {
                    name: "Verification Duration",
                    value: `${data.validationDuration} seconds`,
                },
                { name: "Verification Start Time", value: new Date(data.validationStartTime).toLocaleString() },
                { name: "Verification End Time", value: new Date(data.validationEndTime).toLocaleString() },
                { name: "Number of Records", value: data.numberOfRecords },
                { name: "Uploaded On", value: new Date(data.createdAt).toLocaleString() },
                { name: "Uploaded By", value: `${data.uploadedBy.firstName} ${data.uploadedBy.lastName}` },
            ];
            this.approvedTemplateUrl = data.batchExcelFile;
            this.loading = false;
        } catch (err) {
            console.error("Failed to load promotions:", err);
        } finally {
            this.loading = false;
        }
    },
    methods: {
        handlegoback() {
            // this.$router.push("/admin/staff-promotion");
            this.$router.back();
        },
        downloadItem() {
            alert("Downloading report...");
        },
        getStatus() {
            const statusItem = this.items.find(item => item.name === "Verification Status");
            return statusItem ? statusItem.value : null;
        },

        async deleteItem() {
            const batchId = this.$route.params.id;
            Swal.fire({
                title: "Are you sure?",
                text: "This action cannot be undone. The batch will be permanently deleted.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#d33",
                cancelButtonColor: "#3085d6",
                confirmButtonText: "Yes, delete it!",
                cancelButtonText: "Cancel",
                customClass: {
                    popup: "rounded-2xl p-4",
                    title: "text-lg font-semibold text-gray-800 mb-1",
                    htmlContainer: "text-sm text-gray-600",
                    confirmButton: "px-6 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700",
                    cancelButton: "px-6 py-2 rounded-lg bg-gray-200 text-gray-700 hover:bg-gray-300"
                }
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        await this.$http.delete(`/staff-promotion/bulk-upload/${batchId}`);
                        Swal.fire({
                            title: "Deleted",
                            text: "Batch successfully deleted.",
                            icon: "success",
                            confirmButtonColor: "#1A8103",
                            confirmButtonText: "Ok",
                            customClass: {
                                popup: "rounded-2xl p-4",
                                title: "text-lg font-semibold text-gray-800 mb-1",
                                htmlContainer: "text-sm text-gray-600",
                                confirmButton: "px-20 py-2 rounded-lg bg-green-700 text-white hover:bg-green-800"
                            }
                        }).then(() => {
                            router.push("/admin/staff-promotion");
                        });
                    } catch (error) {
                        console.error(error);
                        Swal.fire("Error", "Failed to delete batch. Please try again.", "error");
                    }
                }
            });
        },

        async submitItem() {
            const batchId = this.$route.params.id;

            // Show confirmation alert first
            const result = await Swal.fire({
                title: "Are you sure?",
                text: "Once submitted, you cannot modify this upload.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#1A8103",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, submit it!",
                cancelButtonText: "Cancel",
                reverseButtons: true,
                width: 350,
                customClass: {
                    popup: 'rounded-2xl p-4',
                    title: 'text-lg font-semibold text-gray-800 mb-1',
                    htmlContainer: 'text-sm text-gray-600',
                    confirmButton: 'px-5 py-2 rounded-lg bg-green-700 text-white hover:bg-green-800',
                    cancelButton: 'px-5 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700'
                }
            });

            if (!result.isConfirmed) return; // If user clicks cancel, stop here.

            try {
                await this.$http.post(`/staff-promotion/submit-bulk-upload/${batchId}`);
                Swal.fire({
                    title: "File received, validating...",
                    text: "Feedback will be available soon.",
                    icon: "success",
                    width: 350,
                    showCancelButton: false,
                    confirmButtonColor: "#1A8103",
                    confirmButtonText: "Ok",
                    customClass: {
                        popup: 'rounded-2xl p-4',
                        title: 'text-lg font-semibold text-gray-800 mb-1',
                        htmlContainer: 'text-sm text-gray-600',
                        confirmButton: 'px-20 py-2 rounded-lg bg-green-700 text-white hover:bg-green-800'
                    }
                }).then(() => {
                    router.push("/admin/promotion/list-bulk-upload");
                });
            } catch (error) {
                console.error(error);
                Swal.fire({
                    title: "Error",
                    text: "Something went wrong while submitting.",
                    icon: "error",
                    confirmButtonColor: "#d33"
                });
            }
        },

        closeModal() {
            this.$emit("close-modal");
        },

    },
};
</script>
